var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[(_vm.observatory)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Back to Observatory',
          icon: 'fas fa-arrow-left text-black',
          path: '/observatory'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Pulse Dashboard',
          icon: 'fas fa-tachometer-alt text-black',
          path:  _vm.observatoryPath + '/pulse/dashboard'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Weekly Scoreboard',
          icon: 'fas fa-list text-black',
          path:  _vm.observatoryPath + '/pulse/weekly-scoreboard'
        }}})],1):_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Pulse Dashboard',
          icon: 'fas fa-tachometer-alt text-black',
          path: '/pulse/dashboard'
        }}}),(_vm.user.pulse_admin)?_c('sidebar-item',{attrs:{"link":{
          name: 'Pulse Users',
          icon: 'fas fa-users text-black',
          path: '/pulse/users'
        }}}):_vm._e(),_c('div',{staticClass:"nav-item"},[_c('b-link',{directives:[{name:"b-modal",rawName:"v-b-modal.pulse-goals",modifiers:{"pulse-goals":true}}],staticClass:"nav-link"},[_c('i',{staticClass:"fas fa-calculator"}),_vm._v(" "),_c('span',{staticClass:"nav-link-text"},[_vm._v("Annual Goal Calculator")])])],1),_c('sidebar-item',{attrs:{"link":{
          name: 'Weekly Scoreboard',
          icon: 'fas fa-list text-black',
          path: '/pulse/weekly-scoreboard'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: 'Add Viewers',
          icon: 'fas fa-eye text-black',
          path: '/pulse/viewers'
        }}})],1),_c('template',{slot:"links-after"},[(_vm.portalAccess)?_c('hr',{staticClass:"my-3"}):_vm._e(),_c('b-nav',{staticClass:"navbar-nav mb-md-3"},[_c('div',{staticClass:"nav-item"},[_c('b-link',{staticClass:"nav-link",attrs:{"href":"https://maps.mykajabi.com/login"}},[_c('i',{staticClass:"fas fa-home"}),_vm._v(" "),_c('span',{staticClass:"nav-link-text"},[_vm._v("Back")])])],1),_c('sidebar-item',{attrs:{"link":{
            name: 'Account Settings',
            icon: 'fas fa-cog text-black',
            path: '/account-settings'
          }}})],1)],1)],2),_c('div',{staticClass:"main-content"},[_c('pulse-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1),_c('referral-modal'),_c('pulse-annual-goals')],1)}
var staticRenderFns = []

export { render, staticRenderFns }